/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_BackgroundTaskAttributes_ } from '../models/ControllerResponse_BackgroundTaskAttributes_';
import type { ControllerResponse_IndexBackgroundTasks_Array_ } from '../models/ControllerResponse_IndexBackgroundTasks_Array_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TaskService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ControllerResponse_IndexBackgroundTasks_Array_ Ok
     * @throws ApiError
     */
    public index(): CancelablePromise<ControllerResponse_IndexBackgroundTasks_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/task',
        });
    }
    /**
     * @param taskId
     * @returns ControllerResponse_BackgroundTaskAttributes_ Ok
     * @throws ApiError
     */
    public show(
        taskId: number,
    ): CancelablePromise<ControllerResponse_BackgroundTaskAttributes_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/task/{taskId}',
            path: {
                'taskId': taskId,
            },
        });
    }
}
